export default __webpack_public_path__ + "static/media/Avatar-18-noback.f83fd829.png";